module.exports = __webpack_public_path__ + "static/media/grade-1-tb.b2e7885e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/grade-1-tb.jpg
// module id = 149
// module chunks = 0